import React from 'react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import Gallery from '../components/Gallery';

export default function GalleryPage() {
  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta 
        title="Wedding Photo Gallery | Padua Weddings" 
        description="Browse our wedding gallery to see real celebrations at Padua Hills Theatre. View our ceremony spaces, ballroom receptions, and stunning sunset portraits." 
      />
      
      <PageHero 
        title="The Gallery" 
        subtitle="A glimpse into the cinematic moments and elegant celebrations hosted at Padua."
        image="https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Melissa-and-Jonathan-52.jpg"
      />

      <div className="pt-16">
        <Gallery />
      </div>

      <CTASection />
    </main>
  );
}